(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["design-preview"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__designPreviewInit) return;
    window.__designPreviewInit = true;

    var IMAGE_OK = /^image\/(png|jpe?g|webp|gif)$/i;
    var states = [];

    function currentVariantId() {
      var el = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return el ? String(el.value) : '';
    }

    function loadImage(url, cb) {
      if (!url) { cb(null); return; }
      var img = new Image();
      img.onload = function () { cb(img); };
      img.onerror = function () { cb(null); };
      img.src = url;
    }

    function draw(s) {
      var c = s.canvas, ctx = c.getContext('2d'), W = c.width, H = c.height;
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = '#f2f2f2';
      ctx.fillRect(0, 0, W, H);
      if (s.garment) {
        var gw = s.garment.naturalWidth, gh = s.garment.naturalHeight;
        var k = Math.max(W / gw, H / gh);
        var dw = gw * k, dh = gh * k;
        s.gx = (W - dw) / 2; s.gy = (H - dh) / 2; s.gdw = dw; s.gdh = dh;
        ctx.drawImage(s.garment, s.gx, s.gy, dw, dh);
      }
      if (!s.art) return;
      var baseW = W * (s.w / 100) * (s.scale / 100);
      var aw = baseW, ah = baseW * (s.art.naturalHeight / s.art.naturalWidth);
      var cx = W * (s.x / 100) + s.ox, cy = H * (s.y / 100) + s.oy;
      var left = cx - aw / 2, top = cy - ah / 2;
      ctx.drawImage(s.art, left, top, aw, ah);
      if (s.garment) {
        var t = s.tmp;
        t.width = W; t.height = H;
        var tctx = t.getContext('2d');
        tctx.clearRect(0, 0, W, H);
        tctx.drawImage(s.art, left, top, aw, ah);
        tctx.globalCompositeOperation = 'source-in';
        tctx.drawImage(s.garment, s.gx, s.gy, s.gdw, s.gdh);
        ctx.save();
        ctx.globalCompositeOperation = 'multiply';
        ctx.globalAlpha = 0.25;
        ctx.drawImage(t, 0, 0);
        ctx.restore();
      }
    }

    function syncGarment(s) {
      var id = currentVariantId();
      if (id === s.variantId && s.garmentLoaded) return;
      s.variantId = id;
      var url = (s.images.variants && s.images.variants[id]) || s.images['default'];
      s.garmentLoaded = true;
      loadImage(url, function (img) { s.garment = img; draw(s); });
    }

    function setup(root) {
      var imgs = {};
      try { imgs = JSON.parse(root.querySelector('[data-dp-images]').textContent); } catch (e) {}
      var s = {
        root: root,
        body: root.querySelector('.dp__body'),
        canvas: root.querySelector('.dp__canvas'),
        scaleInput: root.querySelector('.dp__scale'),
        pdf: root.querySelector('.dp__pdf'),
        tmp: document.createElement('canvas'),
        images: imgs,
        x: parseFloat(root.getAttribute('data-x')) || 50,
        y: parseFloat(root.getAttribute('data-y')) || 36,
        w: parseFloat(root.getAttribute('data-w')) || 34,
        scale: 100, ox: 0, oy: 0, art: null, garment: null,
        variantId: null, garmentLoaded: false, url: null
      };
      s.scaleInput.addEventListener('input', function () {
        s.scale = parseFloat(s.scaleInput.value) || 100;
        draw(s);
      });
      var drag = null;
      s.canvas.addEventListener('pointerdown', function (e) {
        drag = { px: e.clientX, py: e.clientY, ox: s.ox, oy: s.oy };
        s.canvas.setPointerCapture(e.pointerId);
      });
      s.canvas.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var r = s.canvas.getBoundingClientRect();
        var f = s.canvas.width / r.width;
        s.ox = drag.ox + (e.clientX - drag.px) * f;
        s.oy = drag.oy + (e.clientY - drag.py) * f;
        draw(s);
      });
      var end = function () { drag = null; };
      s.canvas.addEventListener('pointerup', end);
      s.canvas.addEventListener('pointercancel', end);
      states.push(s);
    }

    function showFile(s, file) {
      s.root.hidden = false;
      s.body.hidden = false;
      var editorNote = s.root.querySelector('.dp__editor-note');
      if (editorNote) editorNote.hidden = true;
      if (!IMAGE_OK.test(file.type)) {
        s.canvas.parentNode.hidden = true;
        s.scaleInput.parentNode.hidden = true;
        s.pdf.hidden = false;
        return;
      }
      s.canvas.parentNode.hidden = false;
      s.scaleInput.parentNode.hidden = false;
      s.pdf.hidden = true;
      if (s.url) URL.revokeObjectURL(s.url);
      s.url = URL.createObjectURL(file);
      s.ox = 0; s.oy = 0; s.scale = 100; s.scaleInput.value = 100;
      syncGarment(s);
      loadImage(s.url, function (img) { s.art = img; draw(s); });
    }

    function init() {
      document.querySelectorAll('[data-dp]').forEach(function (root) {
        if (!root.__dpReady) { root.__dpReady = true; setup(root); }
      });
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT' || t.type !== 'file') return;
      var file = t.files && t.files[0];
      if (!file) return;
      init();
      states.forEach(function (s) { showFile(s, file); });
    }, true);

    setInterval(function () {
      states.forEach(function (s) {
        if (!s.root.hidden && s.art) syncGarment(s);
      });
    }, 500);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
